import { QueryClient } from '@tanstack/react-query';

import queryErrorHandler from './queryErrorHandler';

/**
 * pages router(QueryProvider)와 app router(AppQueryProvider)가 같은 기본 옵션을 쓰도록
 * 한 곳에서 만든다. 두 곳에 따로 두면 조용히 갈라진다.
 */
export default function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: 0,
        // BUG: 서버사이드 버그
        // onError: queryErrorHandler,
        refetchOnWindowFocus: false,
        // suspense: true,
        staleTime: 60 * 1000,
      },
      mutations: {
        retry: 0,
        onError: queryErrorHandler,
      },
    },
  });
}
